<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <h2>
      ２次マニフェスト作成
    </h2>
    <linkage-form />
  </v-container>
</template>

<script>
import LinkageForm from './_Form'
export default {
  name: 'DriverManifestLinkageNew',
  components: {
    LinkageForm
  },
  data () {
    return {
      breadcrumbs: [
        { text: '１次２次紐付け', disabled: false, to: '/driver/manifest/linkages', exact: true },
        { text: '２次マニフェスト作成', disabled: true, to: '' },
      ],
    }
  },
  computed: {},
  watch: {},
  created() {},
  methods: {},
}
</script>

<style scoped>

</style>
